import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { BlockAlign } from '../../../../models/BlockSettings';

interface BlockAlignPickerProps {
  value: BlockAlign;
  direction: 'row' | 'column';
  hasStretch?: boolean;
  onChangeAlign: (value: BlockAlign) => void;
}

const BlockAlignPicker = ({
  value, direction, hasStretch = true, onChangeAlign,
}: BlockAlignPickerProps) => (
  <Box>
    {direction === 'column' ? '水平方向の位置' : '垂直方向の位置'}
    <ToggleButtonGroup
      color="primary"
      value={value}
      exclusive
      onChange={(_, newValue: BlockAlign) => {
        if (newValue) {
          onChangeAlign(newValue);
        }
      }}
      size="small"
      sx={{ marginLeft: 3 }}
    >
      <ToggleButton value={BlockAlign.START} sx={{ paddingX: 2, paddingY: 1 }}>{direction === 'column' ? '左寄せ' : '上揃え'}</ToggleButton>
      <ToggleButton value={BlockAlign.CENTER} sx={{ paddingX: 2, paddingY: 1 }}>{direction === 'column' ? '中央' : '中央揃え'}</ToggleButton>
      <ToggleButton value={BlockAlign.END} sx={{ paddingX: 2, paddingY: 1 }}>{direction === 'column' ? '右寄せ' : '下揃え'}</ToggleButton>
      {hasStretch && <ToggleButton value={BlockAlign.STRETCH} sx={{ paddingX: 2, paddingY: 1 }}>{direction === 'column' ? '横フル表示' : '縦フル表示'}</ToggleButton>}
    </ToggleButtonGroup>
  </Box>
);

export default BlockAlignPicker;
